import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectThemeMode } from '@/store/slices/theme.selectors';
import { setMode, toggleMode } from '@/store/slices/theme.slice';
import type { ThemeMode } from '@/types/common.types';

export function useAppTheme() {
  const dispatch = useAppDispatch();
  const mode = useAppSelector(selectThemeMode);

  const setThemeMode = useCallback((next: ThemeMode) => dispatch(setMode(next)), [dispatch]);
  const toggleThemeMode = useCallback(() => dispatch(toggleMode()), [dispatch]);

  return { mode, setThemeMode, toggleThemeMode };
}
